<template>
  <div>
    <div class="card"
         id="detail-command">
      <detail-facture :facture="facture"
                      :factureDetail="factureDetail"
                      :isEditPrevisu="isEditPrevisu"
                      :isPrevisualisation="isPrevisualisation"
                      :isEdit="isEdit"
                      @masqueRemiseChange="$emit('masqueRemiseChange', $event)"
                      @masqueLigneChange="$emit('masqueLigneChange', $event)">
      </detail-facture>
    </div>
    <template v-if="facture.commentaireInterne || estApplciationTvaIntracom">
      <div class="card mgt-20px"
           id="detail-comments">
        <header class="header-card">
          <p>
            {{ $t('editionClient.generalTitle.comments')}}
          </p>
        </header>
        <div class="card-content columns">
          <div class="column">
            <div class="mgb-10px">
              <strong>{{ $t('editionCommande.informations.internCommentary') }}</strong>
            </div>
            <span>{{ facture.commentaireInterne }}</span>
          </div>
          <div class="column" v-if="estApplciationTvaIntracom">
            <div class="mgb-10px">
              <strong>{{ $t('editionCommande.informations.intracomCommentary') }}</strong>
            </div>
            <span v-html="societeActive.commentaireFactureIntracommunautaire"></span>
          </div>
        </div>
      </div>
    </template>
    <detail-echeancier-paiement
      v-if="!isCommandeAchatFournisseur"
      :facture-detail="factureDetail"
      :is-edit="isEdit"
      :facture="facture">
    </detail-echeancier-paiement>
    <detail-avoir :facture-detail="factureDetail" :is-edit="isEdit" :isVenteInterne="false">
    </detail-avoir>
    <div class="card mgt-20px" id="attachments" v-if="!isEdit">
      <header class="header-card">
        <p>
          {{ $t('piecesJointes.attachments')}}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes :checkPermissions=checkPermissions(constantes.FACTURES.maj)
                            readOnly
                            deletable
                            autoSave
                            :canAddOrDeletePj="activeButtonEtLien"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import detailEcheancierPaiement from '@/components/bodac/facture/detail/detailEcheancierPaiement';
import PiecesJointes from '@/components/general/piecesJointes';
import { FACTURES } from '@/configuration/permissionsBodacConf';
import detailFacture from '@/components/bodac/facture/detail/detailFacture';
import detailAvoir from '@/components/bodac/facture/detail/detailAvoir';
import { APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE } from '@/configuration/tiers/tiersConf';
import { SENS_ACHAT, TYPE_COMMANDE, MODULE_ACHAT } from '@/configuration/devisConf';

const Societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    facture: {
      type: Object,
      required: true,
    },
    factureDetail: {
      type: Object,
      required: true,
    },
    isEditPrevisu: {
      type: Boolean,
      required: false,
    },
    isPrevisualisation: {
      type: Boolean,
      required: false,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      constantes: {
        FACTURES,
      },
    };
  },
  components: {
    appPiecesJointes: PiecesJointes,
    detailEcheancierPaiement,
    detailFacture,
    detailAvoir,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    activeButtonEtLien() {
      return this.checkIfCurrentSociety(this.factureDetail.societeId);
    },
    estApplciationTvaIntracom() {
      const annocneur = this.factureDetail.intervenants.find((int) => int.annonceur);
      return annocneur?.applicationTva === APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE;
    },
    isCommandeAchatFournisseur() {
      return this.factureDetail.module === MODULE_ACHAT
        && this.factureDetail.sens === SENS_ACHAT
        && this.factureDetail.type === TYPE_COMMANDE;
    },
  },
};
</script>
